// import React, { useState } from "react";
// import tw from "tailwind-styled-components";
// import { Formik, Field, Form } from "formik";
// import Images from "../../Images";
// import {
//   InputGroup,
//   FieldWrapper,
//   Label,
//   SubmitBtn,
//   CombineInputGroup,
// } from "../Styles/InputStyles";
// import Loading from "../Loading";
// import { MdClose } from "react-icons/md";
// import * as Yup from "yup";
// import { useFormik } from "formik";
// import MenuItem from "@mui/material/MenuItem";
// import Select from "@mui/material/Select";
// import moment from "moment";

// const MarkAsPaidModel = ({
//   collectionDate,
//   partialPayment,
//   paymentMode,
//   transactionId,
//   setIsMarkAsPaidVisible,
//   additionalFields = {},
//   MarkAsPaidLoading,
//   excessAmount,
//   partialAmount,
// }) => {
//   const initialValues = {
//     collectionDate: "",
//     partialPayment: "",
//     paymentMode: "",
//     transactionId: "",
//     partialAmount: "",
//     excessAmount: "",
//   };

//   const [partialId, setPartialId] = useState("0");
//   // console.log(partialId, "partialId");

//   const markAsPaidFormik = useFormik({
//     initialValues: {
//       transactionId: transactionId || "",
//       partialPayment: partialPayment || "",
//       collectionDate: moment(collectionDate).format("YYYY-MM-DD"),
//       paymentMode: paymentMode,
//       partialAmount: partialAmount || "",
//       excessAmount: excessAmount || "",
//     },
//     validationSchema: Yup.object({
//       transactionId: Yup.string().required("transactionId is required"),
//       partialPayment: Yup.number().required("partialPayment is required"),
//       collectionDate: Yup.date().required("collection Date is required"),
//       paymentMode: Yup.number().required("paymentMode is required"),
//       partialAmount: Yup.number(),
//       excessAmount: Yup.number(),
//     }),
//     onSubmit: (values) => {
//       // console.log("Form values submitted:", values);
//       // setPartialId(values.partialPayment);
//       //   addRentDetailMutate(values);
//     },
//     enableReinitialize: true,
//   });

//   const handleClose = () => {
//     setIsMarkAsPaidVisible(false);
//   };

//   return (
//     <div className="bg-white w-full h-full flex flex-col">
//       <div className="flex items-center justify-between bg-[#0078BD] py-8 px-4">
//         <Title className="text-white">Mark as Paid</Title>
//         <button onClick={handleClose}>
//           <MdClose color="white" size={24} />
//         </button>
//       </div>
//       {!MarkAsPaidLoading && <Loading />}

//       <div className="px-4 h-full flex flex-col justify-between pb-4 relative">
//         {MarkAsPaidLoading && (
//           <div>
//             <form
//               className="flex flex-col h-full justify-between"
//               onSubmit={markAsPaidFormik.handleSubmit}
//             >
//               <Wrapper>
//                 <InputGroup>
//                   <Label htmlFor="collectionDate">Collection Date *</Label>
//                   <FieldWrapper className="relative">
//                     <Input
//                       type="date"
//                       name="collectionDate"
//                       id="collectionDate"
//                       className="pl-7"
//                       value={markAsPaidFormik.values.collectionDate}
//                       onChange={markAsPaidFormik.handleChange}
//                       onBlur={markAsPaidFormik.handleBlur}
//                     />
//                     {markAsPaidFormik.touched.collectionDate &&
//                       markAsPaidFormik.errors.collectionDate && (
//                         <p className="text-rose-600 text-sm">
//                           {markAsPaidFormik.errors.collectionDate}
//                         </p>
//                       )}
//                     <img
//                       src={Images.Calender}
//                       alt="Calendar icon"
//                       className="absolute left-2 top-1/2 transform -translate-y-1/2 w-4 h-4 cursor-pointer"
//                     />
//                   </FieldWrapper>
//                 </InputGroup>

//                 <InputGroup>
//                   <Label htmlFor="partialPayment">Partial Payment *</Label>
//                   <FieldWrapper $select={true}>
//                     <Select
//                       name="partialPayment"
//                       id="partialPayment"
//                       value={markAsPaidFormik.values.partialPayment}
//                       onChange={markAsPaidFormik.handleChange}
//                       className="w-full pl-2"
//                       style={{ height: "40px" }}
//                       displayEmpty
//                     >
//                       <MenuItem
//                         value="1"
//                         onClick={() => {
//                           setPartialId("1");
//                         }}
//                       >
//                         Full Payment
//                       </MenuItem>
//                       <MenuItem
//                         value="2"
//                         onClick={() => {
//                           setPartialId("2");
//                         }}
//                       >
//                         Partial Payment
//                       </MenuItem>
//                       <MenuItem
//                         value="3"
//                         onClick={() => {
//                           setPartialId("3");
//                         }}
//                       >
//                         Excess Payment
//                       </MenuItem>
//                     </Select>
//                     {markAsPaidFormik.touched.partialPayment &&
//                       markAsPaidFormik.errors.partialPayment && (
//                         <p className="text-rose-600 text-sm">
//                           {markAsPaidFormik.errors.partialPayment}
//                         </p>
//                       )}
//                   </FieldWrapper>
//                 </InputGroup>

//                 {partialId === "2" && (
//                   <InputGroup>
//                     <Label htmlFor="partialAmount">
//                       Enter Partial Payment *
//                     </Label>
//                     <FieldWrapper>
//                       <Input
//                         type="text"
//                         id="partialAmount"
//                         name="partialAmount"
//                         value={markAsPaidFormik.values.partialAmount}
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           if (/^\d*$/.test(value)) {
//                             markAsPaidFormik.setFieldValue(
//                               "partialAmount",
//                               value
//                             );
//                           }
//                         }}
//                         onBlur={markAsPaidFormik.handleBlur}
//                       />
//                       {markAsPaidFormik.touched.partialAmount &&
//                         markAsPaidFormik.errors.partialAmount && (
//                           <p className="text-rose-600 text-sm">
//                             {markAsPaidFormik.errors.partialAmount}
//                           </p>
//                         )}
//                     </FieldWrapper>
//                   </InputGroup>
//                 )}
//                 {partialId === "3" && (
//                   <InputGroup>
//                     <Label htmlFor="excessAmount">Enter Excess Payment *</Label>
//                     <FieldWrapper>
//                       <Input
//                         type="text"
//                         id="excessAmount"
//                         name="excessAmount"
//                         value={markAsPaidFormik.values.excessAmount}
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           if (/^\d*$/.test(value)) {
//                             markAsPaidFormik.setFieldValue(
//                               "excessAmount",
//                               value
//                             );
//                           }
//                         }}
//                         onBlur={markAsPaidFormik.handleBlur}
//                       />
//                       {markAsPaidFormik.touched.excessAmount &&
//                         markAsPaidFormik.errors.excessAmount && (
//                           <p className="text-rose-600 text-sm">
//                             {markAsPaidFormik.errors.excessAmount}
//                           </p>
//                         )}
//                     </FieldWrapper>
//                   </InputGroup>
//                 )}
//                 <InputGroup>
//                   <Label htmlFor="paymentMode">Payment Mode *</Label>
//                   <FieldWrapper $select={true}>
//                     <Select
//                       name="paymentMode"
//                       id="paymentMode"
//                       value={markAsPaidFormik.values.paymentMode}
//                       onChange={markAsPaidFormik.handleChange}
//                       className="w-full pl-2"
//                       style={{ height: "40px" }}
//                       displayEmpty
//                     >
//                       <MenuItem value="1">Offline</MenuItem>
//                       <MenuItem value="2">UPI</MenuItem>
//                       <MenuItem value="3">Netbanking</MenuItem>
//                       <MenuItem value="4">Card</MenuItem>
//                     </Select>
//                     {markAsPaidFormik.touched.paymentMode &&
//                       markAsPaidFormik.errors.paymentMode && (
//                         <p className="text-rose-600 text-sm">
//                           {markAsPaidFormik.errors.paymentMode}
//                         </p>
//                       )}
//                   </FieldWrapper>
//                 </InputGroup>

//                 <InputGroup>
//                   <Label htmlFor="transationID">Transation ID *</Label>
//                   <FieldWrapper>
//                     <Input
//                       type="text"
//                       id="transationID"
//                       name="transationID"
//                       value={markAsPaidFormik.values.transactionId}
//                       onChange={(e) => {
//                         const value = e.target.value;
//                         if (/^\d*$/.test(value)) {
//                           markAsPaidFormik.setFieldValue(
//                             "transactionId",
//                             value
//                           );
//                         }
//                       }}
//                       onBlur={markAsPaidFormik.handleBlur}
//                     />
//                     {markAsPaidFormik.touched.transactionId &&
//                       markAsPaidFormik.errors.transactionId && (
//                         <p className="text-rose-600 text-sm">
//                           {markAsPaidFormik.errors.transactionId}
//                         </p>
//                       )}
//                   </FieldWrapper>
//                 </InputGroup>
//               </Wrapper>

//               <div className="flex justify-end absolute bottom-3 right-3">
//                 <BtnWrapper>
//                   <SubmitBtn type="submit">Mark as Paid</SubmitBtn>
//                 </BtnWrapper>
//               </div>
//             </form>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// const Wrapper = tw.div`grid gap-6 my-6`;
// const Title = tw.h1`text-lg md:text-xl font-medium text-center text-gray-800`;
// const BtnWrapper = tw.div`flex justify-center items-center`;
// const MediaCharCount = tw.div`absolute top-2.5 right-2 text-xs text-gray-400`;
// const Input = tw.input``;
// export default MarkAsPaidModel;

import React, { useState } from "react";
import tw from "tailwind-styled-components";
import { Formik, Field, Form } from "formik";
import Images from "../../Images";
import {
  InputGroup,
  FieldWrapper,
  Label,
  SubmitBtn,
  CombineInputGroup,
} from "../Styles/InputStyles";
import Loading from "../Loading";
import {
  MdAccountBalance,
  MdClose,
  MdCreditCard,
  MdQrCodeScanner,
  MdMoney,
} from "react-icons/md";
import * as Yup from "yup";
import { useFormik } from "formik";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import moment from "moment";

const MarkAsPaidModel = ({
  collectionDate,
  partialPayment,
  paymentMode,
  transactionId,
  setIsMarkAsPaidVisible,
  additionalFields = {},
  MarkAsPaidLoading,
  excessAmount,
  partialAmount,
}) => {
  //   const paymentModes = [
  //     { value: 1, label: "Offline", icon: <img src={Images.Offline} alt="Offline" className="w-10 h-10" /> },
  //     { value: 2, label: "UPI", icon: <img src={Images.UPI} alt="UPI" className="w-10 h-10" /> },
  //     { value: 3, label: "Net Banking", icon: <img src={Images.Netbanking} alt="Net Banking" className="w-10 h-10" /> },
  //     { value: 4, label: "Card", icon: <img src={Images.Card} alt="Card" className="w-10 h-10" /> },
  // ];
  const paymentModes = [
    { value: 1, label: "Offline", icon: <MdMoney size={24} /> },
    { value: 2, label: "UPI", icon: <MdQrCodeScanner size={24} /> },
    { value: 3, label: "Net Banking", icon: <MdAccountBalance size={24} /> },
    { value: 4, label: "Card", icon: <MdCreditCard size={24} /> },
  ];

  const [partialId, setPartialId] = useState("0");

  const formik = useFormik({
    initialValues: {
      transactionId: transactionId || "",
      partialPayment: partialPayment || "",
      collectionDate: moment(collectionDate).format("YYYY-MM-DD"),
      paymentMode: paymentMode,
      partialAmount: partialAmount || "",
      excessAmount: excessAmount || "",
    },
    validationSchema: Yup.object({
      transactionId: Yup.string().required("Transaction ID is required"),
      partialPayment: Yup.string().required("Please select a payment type"),
      collectionDate: Yup.date().required("Collection Date is required"),
      paymentMode: Yup.number().required("Payment mode is required"),
      partialAmount: Yup.number().when('partialPayment', {
        is: (value) => value === "2", // Check if partialPayment is "2"
        then: Yup.number().required("Partial amount is required"),
        otherwise: Yup.number().notRequired(), // Optional if not "2"
      }),
      excessAmount: Yup.number().when('partialPayment', {
        is: (value) => value === "3", // Check if partialPayment is "3"
        then: Yup.number().required("Excess amount is required"),
        otherwise: Yup.number().notRequired(), // Optional if not "3"
      }),
    }),
    onSubmit: (values) => {
      console.log("Form values submitted:", values);
      // setPartialId(values.partialPayment);
      //   addRentDetailMutate(values);
    },
    enableReinitialize: true,
  });

  return (
    <div className="bg-white w-full h-full flex flex-col">
      <div className="flex items-center justify-between bg-[#0078BD] py-8 px-4">
        <Title className="text-white">Mark as Paid</Title>
        <button onClick={() => setIsMarkAsPaidVisible(false)}>
          <MdClose color="white" size={24} />
        </button>
      </div>

      {/* {MarkAsPaidLoading && <Loading />} */}

      <div className="px-4 h-full flex flex-col justify-between pb-4 relative">
        {/* {!MarkAsPaidLoading && ( */}
        <form
          className="flex flex-col h-full justify-between"
          onSubmit={formik.handleSubmit}
        >
          <Wrapper>
            <InputGroup className="relative">
              <Label htmlFor="collectionDate">Collection Date *</Label>
              <Input
                type="date"
                id="collectionDate"
                {...formik.getFieldProps("collectionDate")}
              />
              {formik.touched.collectionDate &&
                formik.errors.collectionDate && (
                  <p className="text-rose-600 text-sm">
                    {formik.errors.collectionDate}
                  </p>
                )}
            </InputGroup>

            <PaymentGroup>
              <Label>Partial/Excess Payment</Label>
              <div className="flex flex-col gap-3">
                <PaymentOption
                  isSelected={formik.values.partialPayment === "1"}
                  onClick={() => formik.setFieldValue("partialPayment", "1")}
                >
                  <input
                    type="radio"
                    name="partialPayment"
                    value="1"
                    checked={formik.values.partialPayment === "1"}
                    onChange={formik.handleChange}
                    className="hidden"
                  />
                  <div className="flex items-center gap-3">
                    <RadioCircle
                      isChecked={formik.values.partialPayment === "1"}
                    />
                    <span>Full Payment</span>
                  </div>
                </PaymentOption>

                <PaymentOption
                  isSelected={formik.values.partialPayment === "2"}
                  onClick={() => formik.setFieldValue("partialPayment", "2")}
                >
                  <div className="flex items-center gap-3">
                    <RadioCircle
                      isChecked={formik.values.partialPayment === "2"}
                    />
                    <span>Partial Payment</span>
                  </div>

                  {formik.values.partialPayment === "2" && (
                    <div className="mt-2">
                      <Input
                        type="number"
                        id="partialAmount"
                        placeholder="Enter Partial Amount"
                        {...formik.getFieldProps("partialAmount")}
                      />
                      {formik.touched.partialAmount &&
                        formik.errors.partialAmount && (
                          <p className="text-rose-600 text-sm">
                            {formik.errors.partialAmount}
                          </p>
                        )}
                    </div>
                  )}
                </PaymentOption>

                <PaymentOption
                  isSelected={formik.values.partialPayment === "3"}
                  onClick={() => formik.setFieldValue("partialPayment", "3")}
                >
                  <div className="flex items-center gap-3">
                    <RadioCircle
                      isChecked={formik.values.partialPayment === "3"}
                    />
                    <span>Excess Payment</span>
                  </div>

                  {formik.values.partialPayment === "3" && (
                    <div className="mt-2">
                      <Input
                        type="number"
                        id="excessAmount"
                        placeholder="Enter Excess Amount"
                        {...formik.getFieldProps("excessAmount")}
                      />
                      {formik.touched.excessAmount &&
                        formik.errors.excessAmount && (
                          <p className="text-rose-600 text-sm">
                            {formik.errors.excessAmount}
                          </p>
                        )}
                    </div>
                  )}
                </PaymentOption>
              </div>
            </PaymentGroup>

            <InputGroup>
              <Label>Payment Mode *</Label>
              <PaymentModeWrapper>
                {paymentModes.map((mode) => (
                  <PaymentModeCard
                    key={mode.value}
                    type="button"
                    onClick={() =>
                      formik.setFieldValue("paymentMode", mode.value)
                    }
                    className={
                      formik.values.paymentMode === mode.value
                        ? "bg-blue-200"
                        : "bg-gray-100"
                    }
                  >
                    {mode.icon}
                    <span className="text-sm">{mode.label}</span>
                  </PaymentModeCard>
                ))}
              </PaymentModeWrapper>
            </InputGroup>

            <InputGroup>
              <Label htmlFor="transactionId">Transaction ID *</Label>
              <Input
                type="text"
                id="transactionId"
                {...formik.getFieldProps("transactionId")}
              />
              {formik.touched.transactionId && formik.errors.transactionId && (
                <p className="text-rose-600 text-sm">
                  {formik.errors.transactionId}
                </p>
              )}
            </InputGroup>
          </Wrapper>

          <div className="flex justify-end absolute bottom-3 right-3">
            <SubmitBtn type="submit">Mark as Paid</SubmitBtn>
          </div>
        </form>
        {/* )} */}
      </div>
    </div>
  );
};

const Wrapper = tw.div`grid gap-6 my-6`;
const Title = tw.h1`text-lg md:text-xl font-medium text-center text-gray-800`;
const Input = tw.input`border rounded p-2 w-full`;

const PaymentGroup = tw.div``;
const PaymentOption = tw.div`
  flex flex-col gap-2 p-3 border rounded-lg cursor-pointer
  transition-all duration-200 
`;

const RadioCircle = ({ isChecked }) => (
  <div
    className={`w-4 h-4 rounded-full border-2 flex items-center justify-center ${
      isChecked ? "border-blue-500" : "border-gray-500"
    }`}
  >
    {isChecked && <div className="w-2 h-2 bg-blue-500 rounded-full" />}
  </div>
);

const PaymentModeWrapper = tw.div`grid grid-cols-4 gap-2 my-1.5`;
const PaymentModeCard = tw.button`flex flex-col items-center justify-center p-2 border rounded-lg shadow-sm cursor-pointer`;

export default MarkAsPaidModel;
